import * as Yup from 'yup';

const requiredScoreValidation = Yup.number().nullable().required('Please select a score.');

export const validationSchema: Yup.ObjectSchema<{}> = Yup.object().shape({
  operationalServices: requiredScoreValidation,
  visibility: requiredScoreValidation,
  recommendation: requiredScoreValidation,
  marketConditions: requiredScoreValidation
});
